<div class="sb-modal-grid">
    <section
        role="dialog"
        aria-modal="true"
        aria-label="Add or update data"
        class="sb-modal-grid-container sb-modal-sm"
    >
        <header class="sb-modal-grid-header" style="position: relative">
            <a
                [routerLink]="['', { outlets: { modal: null } }]"
                [queryParamsHandling]="paramStrategy$ | async"
                class="btn close mt-n1 mb-n3 me-md-n2"
                style="right: 1rem; top: 1rem; position: absolute; z-index: 1"
            >
                Close
            </a>
            <div class="row gx-2 justify-content-between mw-100">
                <div class="col">
                    <div class="row gy-2 gx-2">
                        <div [class]="(activeStep$ | async) > 0 ? 'col-auto' : 'col-12'">
                            <sb-asset-type-select
                                appearance="none"
                                [formControl]="assetTypeCtrl"
                            ></sb-asset-type-select>
                        </div>
                        <div class="col-auto" [class.mb-2]="!(activeStep$ | async)">
                            <h2
                                class="mb-1"
                                *ngIf="!(activeStep$ | async) && existingOptions$ | async"
                            >
                                {{ selectInstrumentHeader$ | async }}
                            </h2>
                            <div
                                class="d-flex align-items-start justify-content-between justify-content-sm-start"
                            >
                                <ng-container *ngIf="existingOptions$ | async">
                                    <sb-instrument-select
                                        *ngIf="assetTypeCtrl.value !== 'PRIVATE_EQUITY'"
                                        [instrumentTypes]="instrumentTypes$ | async"
                                        [appearance]="
                                            (activeStep$ | async) > 0 ? 'none' : 'fill'
                                        "
                                        [formControl]="instrumentControl"
                                        [addNewInstrumentRouterLink]="
                                            (addNewUrl$ | async) ?? null
                                        "
                                    ></sb-instrument-select>
                                    <sb-private-equity-company-select
                                        *ngIf="assetTypeCtrl.value === 'PRIVATE_EQUITY'"
                                        [appearance]="
                                            (activeStep$ | async) > 0 ? 'none' : 'fill'
                                        "
                                        [formControl]="instrumentControl"
                                    ></sb-private-equity-company-select>
                                </ng-container>
                                <ng-container
                                    *ngIf="!instrumentControl.value && addNewUrl$ | async"
                                >
                                    <span
                                        class="mx-3 mt-3 font-weight-bold"
                                        *ngIf="existingOptions$ | async"
                                    >
                                        or
                                    </span>
                                    <a
                                        style="margin-top: 5px"
                                        class="btn primary text-nowrap"
                                        [routerLink]="addNewUrl$ | async"
                                    >
                                        Add new
                                    </a>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="titles$ | async as titles">
                        <h2 class="sb-flow-header" *ngIf="titles.length > 0">
                            <ol>
                                <li *ngFor="let title of titles">{{ title }}</li>
                            </ol>
                        </h2>
                    </ng-container>
                </div>
                <div class="col-12">
                    <sb-step-indicator
                        [steps]="steps$ | async"
                        [activeStep]="activeStep$ | async"
                    ></sb-step-indicator>
                </div>
            </div>
        </header>
        <router-outlet></router-outlet>
        <footer class="sb-modal-grid-footer" *ngIf="(activeStep$ | async) <= 1">
            <a
                class="btn primary"
                [routerLink]="['', { outlets: { modal: null } }]"
                [queryParamsHandling]="paramStrategy$ | async"
            >
                Close
            </a>
        </footer>
    </section>
    <a
        class="backdrop"
        [routerLink]="['', { outlets: { modal: null } }]"
        [queryParamsHandling]="paramStrategy$ | async"
    ></a>
</div>
